export const REX_FEATURES_API = host =>
  `/api/v2/hosts/${host}/available_remote_execution_features`;
export const NEW_JOB_PAGE = '/job_invocations/new?host_ids%5B%5D';



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/react_app/components/FeaturesDropdown/constant.js